import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {PopupQuestion as Component} from './PopupQuestion';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    components: getComponents(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const PopupQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

const getCurrentSection = ({notebook}) => notebook.currentSection;

const getComponents = createSelector(
  [getCurrentSection],
  (currentSection) => currentSection.components
);
